var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "results-details-bg" },
    [
      _c("div", { staticClass: "results-details" }, [
        _c("div", { ref: "fixTopComponent", staticClass: "side-menu-box" }, [
          _c("div", { staticClass: "menuFixed" }, [
            _c(
              "div",
              { staticClass: "side-menu" },
              _vm._l(_vm.menuList, function (item) {
                return _c(
                  "a",
                  {
                    key: item.id,
                    staticClass: "menu-item flex items-center",
                    class: {
                      active: item.id === _vm.menuCurrent,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.changeMenu($event, item.id)
                      },
                    },
                  },
                  [_c("span", [_vm._v(_vm._s(item.label))])]
                )
              }),
              0
            ),
            _c(
              "div",
              { staticClass: "addNew", on: { click: _vm.handleBack } },
              [
                _c("i", {
                  staticClass: "el-icon-plus",
                  staticStyle: { "font-size": "14px" },
                }),
                _vm._v("创建新对话"),
              ]
            ),
          ]),
        ]),
        _c("div", { staticClass: "right-content relative" }, [
          _c(
            "div",
            {
              staticClass: "flex items-start justify-between export-pdf-box",
              staticStyle: { height: "36px" },
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "dis-btn",
                  attrs: { type: "text" },
                  on: { click: _vm.handleOpen },
                },
                [_vm._v("我的指令")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "export-pdf",
                  attrs: {
                    disabled: _vm.status !== "SUCCESS",
                    loading: _vm.pdfLoading,
                  },
                  on: { click: _vm.exportPdf },
                },
                [_vm._v("导出PDF")]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              ref: "resultsContainer",
              staticClass: "scroll-content",
              on: { scroll: _vm.watchScroll },
            },
            [
              _c(
                "div",
                { staticClass: "think-content" },
                [
                  _c(
                    "toggle-component",
                    {
                      ref: "toggleRef1",
                      staticStyle: { "margin-bottom": "10px" },
                      attrs: { "default-visible": true },
                    },
                    [
                      _c("div", {
                        staticClass: "markdown-body",
                        domProps: { innerHTML: _vm._s(_vm.thinkingMd) },
                      }),
                    ]
                  ),
                  _vm.startLoading
                    ? _c("p", [_vm._v("正在分析...")])
                    : _vm._e(),
                  _vm.thinkLoading
                    ? _c("p", { staticClass: "load-text" }, [
                        _c("i", { staticClass: "el-icon-loading" }),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _vm.reportLoading
                ? _c("div", [
                    _c(
                      "div",
                      {
                        staticClass: "content-bg",
                        staticStyle: { "margin-bottom": "0" },
                      },
                      [
                        _c("p", [_vm._v("正在生成报告")]),
                        _vm.reporterMd
                          ? _c("p", {
                              staticClass: "markdown-body",
                              domProps: { innerHTML: _vm._s(_vm.reporterMd) },
                            })
                          : _vm._e(),
                        _vm.reportLoading
                          ? _c("p", { staticClass: "load-text" }, [
                              _c("i", { staticClass: "el-icon-loading" }),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ])
                : _vm._e(),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isStreaming && _vm.resultData,
                      expression: "!isStreaming && resultData",
                    },
                  ],
                  staticClass: "list-container",
                  staticStyle: { "margin-top": "20px" },
                },
                _vm._l(_vm.menuList, function (item) {
                  return _c(
                    "div",
                    {
                      key: item.id,
                      staticClass: "list-item",
                      attrs: { id: item.id },
                    },
                    [
                      _c("div", { staticClass: "flex no-select" }, [
                        _c("img", {
                          staticStyle: { "margin-right": "2px" },
                          attrs: {
                            width: "28",
                            height: "18",
                            src: _vm.titleLeft,
                            alt: "",
                          },
                        }),
                        _c("div", { staticClass: "title-bg" }, [
                          _c(
                            "div",
                            {
                              staticClass: "flex justify-center",
                              staticStyle: { padding: "0 6px" },
                            },
                            [_vm._v(_vm._s(item.label))]
                          ),
                          _c("div", { staticClass: "title-bottom" }),
                        ]),
                      ]),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.loading,
                              expression: "loading",
                            },
                          ],
                          staticClass: "content-bg",
                        },
                        [
                          !_vm.resultData[item.label]
                            ? _c("el-empty", { attrs: { "image-size": 140 } })
                            : _c("div", [
                                _c("p", {
                                  staticClass: "markdown-body",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.resultData[item.label]
                                    ),
                                  },
                                }),
                              ]),
                        ],
                        1
                      ),
                    ]
                  )
                }),
                0
              ),
            ]
          ),
        ]),
      ]),
      _c("questionDialog", {
        ref: "questionDialog",
        attrs: { questionData: _vm.question, documentData: _vm.documentName },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }